export enum ComponentId {
  INCIDENT_CIRCUMSTANCES_DATE = "date",
  INCIDENT_CIRCUMSTANCES_HOUR = "hour",
  INCIDENT_CIRCUMSTANCES_PLACE = "place",
  INCIDENT_CIRCUMSTANCES_COUNTRY = "country",
  INCIDENT_CIRCUMSTANCES_PROVINCE = "province",
  INCIDENT_CIRCUMSTANCES_CITY = "city",
  INCIDENT_CIRCUMSTANCES_DESCRIPTION = "description",
  INCIDENT_CIRCUMSTANCES_ZIP_CODE_PL = "zipCodePL",
  INCIDENT_CIRCUMSTANCES_ZIP_CODE_GENERIC = "zipCodeGeneric",
}
